import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

const commonSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.gender,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.roadworthiness,
]

export const frameSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.sku,
  SpecificationsLibrary.brand,
  SpecificationsLibrary.brandModelCode,
  SpecificationsLibrary.frameType,
]

export const sunglassesSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.sku,
  SpecificationsLibrary.brand,
  SpecificationsLibrary.brandModelCode,
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameType,
  SpecificationsLibrary.glazeble,
  SpecificationsLibrary.polarized,
]

export const clSpecifications: SpecificationConfigurationItem[] = [
  ...commonSpecifications,
  SpecificationsLibrary.materialType,
  SpecificationsLibrary.lensType,
  SpecificationsLibrary.waterContent,
]
